import { render } from "./LayoutMobileFooterMenu.vue?vue&type=template&id=b9eefb80"
import script from "./LayoutMobileFooterMenu.vue?vue&type=script&lang=js"
export * from "./LayoutMobileFooterMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__